import React from 'react'
import { MatchesResponse } from 'protos'
import MatchDateGroup from './components/MatchDateGroup'

type Props = {
  dateGroups?: Array<MatchesResponse.IDateGroup>
  onMatchSelect: (matchId: string) => void
}

const SelectMatch = ({ dateGroups, onMatchSelect }: Props) => {
  if (!dateGroups) {
    return null
  }

  return (
    <div>
      {dateGroups.map((dateGroup, i) => <MatchDateGroup dateGroup={dateGroup} key={i} onMatchSelect={onMatchSelect} />)}
    </div>
  )
}

export default SelectMatch
try {
    // @ts-ignore
    SelectMatch.displayName = "SelectMatch";
    // @ts-ignore
    SelectMatch.__docgenInfo = { "description": "", "displayName": "SelectMatch", "props": { "dateGroups": { "defaultValue": null, "description": "", "name": "dateGroups", "required": false, "type": { "name": "any[]" } }, "onMatchSelect": { "defaultValue": null, "description": "", "name": "onMatchSelect", "required": true, "type": { "name": "(matchId: string) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/SelectMatch/SelectMatchScreen/SelectMatch.tsx#SelectMatch"] = { docgenInfo: SelectMatch.__docgenInfo, name: "SelectMatch", path: "src/routes/SelectMatch/SelectMatchScreen/SelectMatch.tsx#SelectMatch" };
}
catch (__react_docgen_typescript_loader_error) { }